###
Support $t() in templates.  Currently only resovles English translations.
###
import { shouldUseStaticData } from 'library/services/helpers'
import $craft from './craft'
import axios from 'axios'
import getTranslationsQuery from 'library/queries/craft/static-translations.gql'
import snakeCase from 'lodash/snakeCase'
import Vue from 'vue'

# Invoke to load translation data and inject $t
export initTranslations = ->

	# Load the data
	translations = formatTranslations await getTranslations()

	# Inject the $t method
	Vue.prototype.$t = (key) -> translations[key] || key

# Fetch the en_US translations
getTranslations = ->
	if shouldUseStaticData()
		staticUrl = "#{process.env.NUXT_APP_URL || ''}/data/en-US-translations.json"
		(await axios.get staticUrl).data
	else await $craft.execute query: getTranslationsQuery

# Concatenate the category onto the message key to match the convention that
# was setup for @nuxt/i18n
formatTranslations = (response) ->
	response.messages.reduce (obj, message) ->
		category = snakeCase message.category
		obj["#{category}.#{message.key}"] = message.message || ''
		return obj
	, {}
